import { render, staticRenderFns } from "./form.component.vue?vue&type=template&id=3db5ae51"
import script from "./form.component.vue?vue&type=script&lang=js"
export * from "./form.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports